import { http } from "../../../shared/api/http"
import { MarketCategory } from "./market-categories.api"

export type ModerationStatus = "on_moderation" | "approved" | "rejected"

export type RelevanceStatus = "active" | "needs_update" | "outdated"

export type VerificationType = "none" | "system" | "buyer" | "admin"

export type MarketItem = {
  id: string
  name: string
  name_cn?: string | null
  pinyin?: string | null
  description?: string | null
  address?: string | null
  metro?: string | null
  moderation_status: ModerationStatus
  verification_type: VerificationType
  relevance_status: RelevanceStatus
  created_by?: string
  category?: MarketCategory | null
  average_rating?: number
  reviews_count?: number
}

export type MarketListResponse = {
  markets: MarketItem[]
  total?: number
}

export type MarketFilters = {
  limit?: number
  offset?: number
  moderation_status?: ModerationStatus | ""
  verification_type?: VerificationType | ""
  relevance_status?: RelevanceStatus | ""
  search?: string
  created_by?: string
}

export const listChinaMarketsApi = (filters: MarketFilters = {}) =>
  http.get<MarketListResponse>("/api/admin/china/markets", {
    params: filters,
  })

export type MarketStatusPayload = {
  moderation_status?: ModerationStatus
  verification_type?: VerificationType
  relevance_status?: RelevanceStatus
}

export const updateChinaMarketStatusApi = (marketId: string, payload: MarketStatusPayload) =>
  http.patch(`/api/admin/china/markets/${marketId}/status`, payload)

export const deleteChinaMarketApi = (marketId: string) =>
  http.delete(`/api/admin/china/markets/${marketId}`)